import styled from 'styled-components'

export const FieldWrapper = styled.div`
  // set min-height to account for error message
  // and avoid shifting other elements when
  // a validation error appears
  min-height: 72px;
`
